export const vendorsGetters = {
  vendorsFormStatus: (state) => state.vendorsFormStatus,
   vendorsGroupFormStatus: (state) => state.vendorsGroupFormStatus,
  vendorsIsEdit: state => state.vendorsIsEdit,
  vendorsGroupIsEdit: state => state.vendorsGroupIsEdit,
  vendorsSelectedForEdit: state => state.vendorsSelectedForEdit,
  vendorsGroupSelectedForEdit: state => state.vendorsGroupSelectedForEdit,
  vendorManageable: state => state.vendorManageable,
  vendorPermissionId: state => state.vendorPermissionId,
 
};